// extracted by mini-css-extract-plugin
export default {"rating":"gA-z","numberOfStars":"hA-z","count":"iA-z","barGraphSpacing":"jA-z","barGraph":"kA-z"};